var loading = "https://shopfront-cdn.tekoapis.com/static/0aca01576f2159f6.svg";

export { loading as default };
